import { $t } from 'hc-core/composables/intl'
import { compact, concat, get, uniq } from 'lodash'
import { alphabeticalOrder } from 'hc-core/utils/array'

// If present and set to true, that defines the new onward behaviour
const NEW_BEHAVIOUR_TIMESTAMP = new Date('2025-04-21T01:01:01.001Z')
export const isLegacyBehaviour = (offer) => {
  // return !get(offer, 'metadata._job.advTooNew', false)
  return new Date(get(offer, 'createdDate', undefined)) <= NEW_BEHAVIOUR_TIMESTAMP
}

// Handling customAttributes of type string storing multiple values separated by space, spaces replaced by underscore
export const customListStringToArray = (str = '') => {
  if (!str) str = ''
  return compact(str.split(' ').map(t => typeof t === 'string' && t && t.length ? t.replace(/_/g, ' ') : null))
}

// Opposite of above method
export const arrayTocustomListString = (arr) => {
  return compact(uniq(arr)).map(t => t.replaceAll(' ', '_')).join(' ')
}

export const getCombinedAdvantages = ({ company, offer }) => {
  const isOfferLegacyBehaviour = isLegacyBehaviour(offer)
  const offerCustomAdvantages = get(offer, 'metadata._job.advantages', [])
  const offerCustomAttributesAdvantages = get(offer, 'customAttributes.advantages', []).map(i => $t(`customAttributes.advantages.${i}`))
  const companyAdvantages = get(company, 'metadata._team.advantages', []).map(i => i.text)
  const advantages = compact(concat(
    offerCustomAdvantages,
    offerCustomAttributesAdvantages,
    isOfferLegacyBehaviour ? companyAdvantages : []
  ))
  return advantages.length ? alphabeticalOrder(advantages) : []
}

export const getCombinedTools = ({ company, offer }) => {
  const isOfferLegacyBehaviour = isLegacyBehaviour(offer)
  const companyTools = get(company, 'customAttributes.tools', []).map(i => $t(`customAttributes.tools.${i}`))
  const companyCustomTools = customListStringToArray(get(company, 'customAttributes.tools_custom', ''))
  const offerTools = get(offer, 'customAttributes.tools', []).map(i => $t(`customAttributes.tools.${i}`))
  const offerCustomTools = customListStringToArray(get(offer, 'customAttributes.tools_custom', ''))
  const tools = compact(concat(
    offerTools,
    offerCustomTools,
    isOfferLegacyBehaviour ? companyTools : [],
    isOfferLegacyBehaviour ? companyCustomTools : []
  ))
  return tools.length ? alphabeticalOrder(tools) : []
}
